import { React, useState } from "react";
import "../App.css";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useUserAuth } from "../auth";

function useQuery() {
	const location = useLocation();
	return new URLSearchParams(location.search);
}
const ResetPasswordPage = () => {
	const query = useQuery();
	const navigate = useNavigate();
	const { resetPassword } = useUserAuth();
	const [visible, setVisible] = useState(false);
	const [newPassword, setNewPassword] = useState("");
	const handleResetPassword = async (e) => {
		e.preventDefault();
		await resetPassword(query.get("oobCode"), newPassword).then(() => {
			navigate("/login");
		});
	};

	return (
		<motion.section initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ ease: "linear", duration: 0.08 }} style={{ backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/space-73.appspot.com/o/Reset-password-pana.svg?alt=media')`, backgroundSize: "600px", backgroundPosition: "left" }}>
			<div id="loginForm" className="loginForm">
				<div className="title-div">
					<h3>Reset Password</h3>
				</div>
				<hr />
				<form onSubmit={handleResetPassword} className="form">
					<div className="form-groups">
						<div className="form-group">
							<input type={visible ? "text" : "password"} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} id="reset_password" name="reset_password" minLength="6" maxLength="20" placeholder="Enter a new valid password" autoComplete="off" required />
							<Icon className="passwordeye" onClick={() => setVisible(!visible)} icon="fluent:eye-16-filled" />
							<label>New Password</label>
						</div>
					</div>
					<div className="buttons">
						<button type="submit" className="btn">
							Submit
						</button>
					</div>
				</form>
				<div className="options">
					<p>Already have an account?</p>
					<Link className="optionlink" to="/login">
						Login
					</Link>
				</div>
			</div>
		</motion.section>
	);
};

export default ResetPasswordPage;
